import { render, staticRenderFns } from "./transverse.vue?vue&type=template&id=7d50f1bb"
import script from "./transverse.vue?vue&type=script&lang=js"
export * from "./transverse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports